import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function LinkPrimaryButton({ children, to, className = '' }) {
  return (
    <motion.div
      whileHover={{ scale: 1.03, y: -2 }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      className={`inline-flex ${className}`}
    >
      <Link
        to={to}
        className="inline-flex items-center justify-center gap-2 px-8 py-4 text-white font-bold text-base rounded-2xl no-underline"
        style={{
          background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',
          boxShadow: '0 4px 15px rgba(37, 99, 235, 0.35), 0 1px 3px rgba(0,0,0,0.12)',
          border: 'none',
          cursor: 'pointer',
          textDecoration: 'none',
        }}
      >
        {children}
      </Link>
    </motion.div>
  );
}